<template>
	<ul class="context-menu" data-testid="context-menu">
		<li
			class="context-menu__item"
			v-for="option in options"
			:key="option.text"
			@mousedown="option.action"
		>
			{{ option.text }}
		</li>
	</ul>
</template>

<script>
import documentClickedMixin from '@/mixins/component-document-clicked-mixin';

export default {
	name: 'ContextMenu',
	mixins: [documentClickedMixin],
	/**
	 * Array of menu options in format:
	 * {
	 * 	text: "Menu Item Name",
	 * 	action: () => {}
	 * }
	 */
	props: {
		options: {
			type: Array,
			default: () => []
		}
	},
	created() {
		this.documentClickedHandler = this.closeHandler;
	},
	methods: {
		closeHandler() {
			this.$emit('onClose');
		}
	}
};
</script>

<style lang="scss" scoped>
.context-menu {
	position: absolute;
	top: 100%;
	margin-left: $gutter-md;
	border: 1px solid var(--menu-list-border);
	background: var(--menu-list-bg);
	color: var(--menu-list-fg);
	border-radius: $border-radius;
	@include medium-shadow;
	z-index: $z-level1-1;

	&__item {
		padding: $padding-sm;
		cursor: pointer;
		white-space: nowrap;

		&:hover {
			background: var(--menu-list-bg-hover);
			color: var(--menu-list-fg-hover);
		}
	}
}
</style>
